<template>
  <div>
    <b-container class="container card">
      <div class="card">
        <div class="card-header">
          <div>
            <i class="fa fa-search"></i>
            <span>بحث</span>
          </div>
        </div>
        <div class="card-body">
          <div class="container">
            <div class="form row card-search">
              <div class="form-group col-md-3">
                <label for="">كود الباص</label>
                <input type="text" class="form-control" v-model="s_id" />
              </div>

              <div class="form-group col-md-3">
                <label for="">رقم اللوحة</label>
                <input type="text" class="form-control" v-model="s_boardNum" />
              </div>

              <div class="form-group col-md-3">
                <label for="">ماركة الباص</label>
                <input type="text" class="form-control" v-model="s_busName" />
              </div>

              <div class="form-group col-md-3">
                <label for="">موديل الباص</label>
                <input type="text" class="form-control" v-model="s_busModel" />
              </div>

              <div class="form-group col-md-3">
                <label for="">المالك</label>
                <select
                  class="browser-default custom-select"
                  v-model="s_ownerBus"
                >
                  <option v-for="emp in emps" :value="emp.id" :key="emp.id">
                    <span> {{ emp.Fname }} </span>
                    <span> {{ emp.Ffname }} </span>
                  </option>
                </select>
              </div>

              <div class="form-group col-md-3 ">
                <label for="">بداية الترخيص</label>
                <div class="form-inline">
                  <select
                    name=""
                    id="lcStart"
                    class="col-md-3 select-par"
                    v-model="lcStart"
                  >
                    <option value="1"><span>اكبر من</span></option>
                    <option value="2"><span>اصغر من</span></option>
                    <option value="3"><span>يساوى</span></option>
                  </select>
                  <input
                    id="id_lcStart"
                    type="text"
                    @blur="lcStart1"
                    class="form-control hijri-date-input col-md-9"
                    v-bind:value="s_lcStart"
                  />
                </div>
              </div>

              <div class="form-group col-md-3 ">
                <label for="">نهاية الترخيص</label>
                <div class="form-inline">
                  <select
                    name=""
                    id="lcEnd"
                    class="col-md-3 select-par"
                    v-model="lcEnd"
                  >
                    <option value="1"><span>اكبر من</span></option>
                    <option value="2"><span>اصغر من</span></option>
                    <option value="3"><span>يساوى</span></option>
                  </select>
                  <input
                    id="id_lcEnd"
                    type="text"
                    @blur="lcEnd1"
                    class="form-control hijri-date-input col-md-9"
                    v-bind:value="s_lcEnd"
                  />
                </div>
              </div>

              <div class="form-group col-md-3">
                <label for="">خط السير من</label>
                <select
                  class="browser-default custom-select"
                  v-model="s_trafficFrom"
                >
                  <option
                    v-for="workarea in workarea"
                    :value="workarea.id"
                    :key="workarea.id"
                  >
                    {{ workarea.areaName }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-3">
                <label for="">خط السير الى</label>
                <select
                  class="browser-default custom-select"
                  v-model="s_trafficTo"
                >
                  <option
                    v-for="traffic in traffic"
                    :value="traffic.id"
                    :key="traffic.id"
                  >
                    {{ traffic.trafficTo }}
                  </option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <button @click="clear" class="btn btn-danger">
                  الغاء البحث
                </button>
                <button v-if="c_print" @click="print" class="btn btn-success">
                  طباعة
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul class="nav nav-tabs view-mode">
        <li class="nav-item ">
          <a class="nav-link active" data-toggle="tab" href="#home">
            <i class="fa fa-table"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#menu1">
            <i class="fa fa-bars"></i>
          </a>
        </li>
      </ul>
      <div class="m-auto">
        <b-button v-if="c_add" to="createBus" variant="outline-primary"
          >إضافة</b-button
        >
        <div class="std-count">
          <span class="text-danger">
            عدد الحافلات
          </span>
          <span> | </span>
          <span class="text-success"> {{ items.length }} </span>
        </div>
      </div>
      <div class="tab-content">
        <div class="tab-pane container active overflow" id="home">
          <!-- Main table element -->

          <b-table
            :busy="isBusy"
            :bordered="true"
            :no-border-collapse="true"
            show-empty
            striped
            hover
            small
            stacked="sm"
            :fields="fields"
            :current-page="currentPage"
            :per-page="10"
            :items="filtered"
            head-variant="dark"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            sort-icon-left
          >
            <template v-slot:head(id) style="background-color:red;">
              <span class="text-info">كود الباص</span>
            </template>

            <template v-slot:table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> جارى التحميل ... </strong>
              </div>
            </template>
            <template v-slot:table-colgroup="scope">
              <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.key === 'id' ? '20px' : '20px' }"
              />
            </template>
            <template slot="top-row" slot-scope="{ fields }">
              <td v-for="field in fields" :key="field.key">
                <input
                  v-model="filters[field.key]"
                  :placeholder="field.label"
                />
              </td>
            </template>
            <template v-slot:cell(actions)="row">
              <b-button
                v-if="c_update"
                size="sm"
                @click="info(row.item, row.index, $event.target)"
                class="mr-1"
                :to="'/updateBus/' + row.item.id"
                variant="outline-warning"
              >
                تعديل
              </b-button>
              <b-button
                v-if="c_delete"
                size="sm"
                @click="info(row.item, row.index, $event.target)"
                class="mr-1"
                variant="outline-danger"
              >
                حذف
              </b-button>
            </template>
          </b-table>
          <b-row>
            <b-col sm="7" md="6" class="m-auto">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class=""
              ></b-pagination>
            </b-col>
          </b-row>
          <!-- Info modal -->
          <b-modal
            :id="infoModal.id"
            hide-footer
            ref="my-modal"
            body-bg-variant="light"
            body-text-variant="danger"
            footer-bg-variant="warning"
            footer-text-variant="light"
            @hide="resetInfoModal"
          >
            <div class="d-block text-center">
              <b-row>
                <div class="card-body">
                  <span>
                    هل انت متأكد من حذف الباص رقم ؟
                  </span>
                  <span class="text-dark">{{ delitem.boardNum }}</span>
                </div>
              </b-row>
              <div class="card-footer">
                <b-container>
                  <b-row>
                    <b-button
                      class="col-md-6 btn-danger"
                      :disabled="busy"
                      @click="remove(delitem)"
                    >
                      <b-spinner
                        v-if="busy"
                        small
                        type="grow"
                        style="margin-bottom: 3px;"
                      ></b-spinner>
                      {{ btnDelMessage }}</b-button
                    >
                    <b-button class="col-md-6 btn-secondary" @click="hideModal"
                      >الغاء</b-button
                    >
                  </b-row>
                </b-container>
              </div>
            </div>
          </b-modal>
        </div>
        <div class="tab-pane container fade" id="menu1">
          <div class="container">
            <div class="row">
              <div class="col-md-3" v-for="item in items" :key="item.id">
                <div class="itm card">
                  <div class="card-header">
                    <span>رقم اللوحة</span>
                    <span> | </span>
                    <span class="text-warning"> {{ item.boardNum }} </span>
                  </div>
                  <table>
                    <tr>
                      <td>كود الباص</td>
                      <td>|</td>
                      <td>{{ item.id }}</td>
                    </tr>
                    <tr>
                      <td>ماركة الباص</td>
                      <td>|</td>
                      <td>{{ item.busName }}</td>
                    </tr>
                    <tr>
                      <td>موديل الباص</td>
                      <td>|</td>
                      <td>{{ item.busModel }}</td>
                    </tr>
                    <tr>
                      <td>المالك</td>
                      <td>|</td>
                      <td>{{ item.emp }}</td>
                    </tr>
                    <tr>
                      <td>بداية الترخيص</td>
                      <td>|</td>
                      <td>{{ item.lcStart }}</td>
                    </tr>
                    <tr>
                      <td>نهاية الرخيص</td>
                      <td>|</td>
                      <td>{{ item.lcEnd }}</td>
                    </tr>
                    <tr>
                      <td>خط السير من</td>
                      <td>|</td>
                      <td>{{ item.vFrom }}</td>
                    </tr>
                    <tr>
                      <td>خط السير الى</td>
                      <td>|</td>
                      <td>{{ item.vTo }}</td>
                    </tr>
                  </table>

                  <div class="card-footer m-auto">
                    <b-button
                      v-if="c_update"
                      size="sm"
                      class="mr-1"
                      :to="'/updateBus/' + item.id"
                      variant="outline-warning"
                    >
                      تعديل
                    </b-button>
                    <b-button
                      v-if="c_delete"
                      size="sm"
                      @click="infoDel(item.id)"
                      class="mr-1"
                      variant="outline-danger"
                    >
                      حذف
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import $ from "jquery";
//import axios from 'axios'
import { mapState, mapGetters, mapActions } from "vuex";
import indexLayout from "../../layouts/indexLayout.vue";
export default {
  name: "buses",
  data() {
    return {
      s_id: "",
      s_busSeats: "",
      s_boardNum: "",
      s_lcStart: "",
      s_lcEnd: "",
      s_busModel: "",
      s_busName: "",
      s_ownerBus: "",
      s_trafficFrom: "",
      s_trafficTo: "",
      lcStart: "",
      lcEnd: "",
      isBusy: true,
      students: [],
      busy: false,
      btnDelMessage: "حذف",
      items: [],
      delitem: "",
      bodyBgVariant: "light",
      bodyTextVariant: "dark",
      footerBgVariant: "warning",
      footerTextVariant: "dark",
      /*check role */
      c_add: false,
      c_update: false,
      c_delete: false,
      c_print: false,

      /*check end */
      fields: [
        {
          key: "id",
          label: "كود الباص",
          sortable: true,
          class: "f-id",
          sortDirection: "desc",
          tdClass: "fid",
        },
        {
          key: "boardNum",
          label: "رقم اللوحة",
          sortable: true,
          class: "text-center",
        },
        {
          key: "busName",
          label: "ماركة الباص",
          sortable: true,
          class: "text-center",
        },
        {
          key: "busModel",
          label: "موديل الباص",
          sortable: true,
          class: "text-center",
        },

        { key: "actions", label: "" },
      ],
      filters: {
        id: "",
        boardNum: "",
        busName: "",
        busModel: "",
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  created() {
    this.$emit("update:layout", indexLayout);
    this.Role_check();
  },

  computed: {
    ...mapGetters({
      load: "busMod/GET_ALLDATA",
      check: "GET_ROLES",
    }),
    ...mapState(["emps", "workarea", "traffic"]),

    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    filtered() {
      const filtered = this.items.filter((item) => {
        return Object.keys(this.filters).every((key) =>
          String(item[key]).includes(this.filters[key])
        );
      });
      return filtered.length > 0
        ? filtered
        : [
            {
              id: "",
              boardNum: "",
              busName: "",
              busModel: "",
            },
          ];
    },
  },
  mounted() {
    this.getData();
    let ckeditor = document.createElement("script");
    //ckeditor.setAttribute('src',"/load.js");
    ckeditor.innerHTML = "$(function () { initHijrDatePicker();  });";
    document.head.appendChild(ckeditor);
  },
  methods: {
    ...mapActions({
      loadData: "busMod/fetchData",
      deleData: "busMod/deleteData",
    }),
    lcStart1() {
      var st = $("#id_lcStart").val();
      this.s_lcStart = st;
      // this.Cfilter();
    },
    lcEnd1() {
      var st = $("#id_lcEnd").val();
      this.s_lcEnd = st;
      // this.Cfilter();
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.delitem = item;
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    infoDel: function(id) {
      var item = this.items.find((todo) => todo.id == id);
      this.infoModal.title = item.id;
      this.delitem = item;
      this.$root.$emit("bv::show::modal", this.infoModal.id);
    },
    async remove(stdRow) {
      this.busy = true;
      await this.deleData(stdRow);
      this.btnDelMessage = "تم الحذف";
      this.busy = false;
      this.items = this.load;
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    async getData() {
      await this.$store.dispatch("busMod/fetchData");
        this.items = this.load;
        this.totalRows = this.items.length;
        this.isBusy = false;

      // if (this.load.length > 0) {
      //   this.items = this.load;
      //   this.totalRows = this.items.length;
      //   this.isBusy = false;
      // } else {
      //   await this.$store.dispatch("busMod/fetchData");
      //   this.items = this.load;
      //   this.totalRows = this.items.length;
      //   this.isBusy = false;
      // }
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    Cfilter() {
      this.items = this.load;
      this.items = this.items.filter((t) =>
        t.id.toString().includes(this.s_id)
      );
      if (this.s_busSeats != "") {
        this.items = this.items.filter((t) =>
          t.busSeats.toString().includes(this.s_busSeats)
        );
      }
      if (this.s_boardNum != "") {
        this.items = this.items.filter((t) =>
          t.boardNum.toString().includes(this.s_boardNum)
        );
      }
      if (this.s_lcStart != "") {
        if (this.lcStart == 1) {
          this.items = this.items.filter((t) => t.lcStart >= this.s_lcStart);
        } else if (this.lcStart == 2) {
          this.items = this.items.filter((t) => t.lcStart <= this.s_lcStart);
        } else if (this.lcStart == 3) {
          this.items = this.items.filter((t) => t.lcStart == this.s_lcStart);
        }
      }
      if (this.s_lcEnd != "") {
        if (this.lcEnd == 1) {
          this.items = this.items.filter((t) => t.lcEnd >= this.s_lcEnd);
        } else if (this.lcEnd == 2) {
          this.items = this.items.filter((t) => t.lcEnd <= this.s_lcEnd);
        } else if (this.lcEnd == 3) {
          this.items = this.items.filter((t) => t.lcEnd == this.s_lcEnd);
        }
      }

      this.items = this.items.filter((t) =>
        t.busModel.toString().includes(this.s_busModel)
      );
      this.items = this.items.filter((t) =>
        t.busName.toString().includes(this.s_busName)
      );
      this.items = this.items.filter((t) =>
        t.ownerBus.toString().includes(this.s_ownerBus)
      );
      this.items = this.items.filter((t) =>
        t.trafficFrom.toString().includes(this.s_trafficFrom)
      );
      this.items = this.items.filter((t) =>
        t.trafficTo.toString().includes(this.s_trafficTo)
      );
    },
    print() {
      this.$router.push({ name: "busR", params: { load: this.items } });
    },
    clear() {
      this.s_id = "";
      this.s_busSeats = "";
      this.s_boardNum = "";
      this.s_lcStart = "";
      this.s_lcEnd = "";
      this.s_busModel = "";
      this.s_busName = "";
      this.s_ownerBus = "";
      this.s_trafficFrom = "";
      this.s_trafficTo = "";
    },
    Role_check() {
      this.c_add = this.check.bus_add == 1 ? true : false;
      this.c_update = this.check.bus_update == 1 ? true : false;
      this.c_delete = this.check.bus_delete == 1 ? true : false;
      this.c_print = this.check.bus_print == 1 ? true : false;
    },
  },
  watch: {
    s_id: function() {
      this.Cfilter();
    },
    s_busSeats: function() {
      this.Cfilter();
    },
    s_boardNum: function() {
      this.Cfilter();
    },
    s_busModel: function() {
      this.Cfilter();
    },
    s_busName: function() {
      this.Cfilter();
    },
    s_trafficFrom: function() {
      this.Cfilter();
    },
    s_lcStart: function() {
      this.Cfilter();
    },
    s_lcEnd: function() {
      this.Cfilter();
    },
    s_trafficTo: function() {
      this.Cfilter();
    },
    s_ownerBus: function() {
      this.Cfilter();
    },
  },
};
</script>
<style lang="scss" scoped>
.b-table-top-row > td:last-child {
  visibility: hidden;
}
.nav-link.active {
  background-color: #ddab2b !important;
}
.fid {
  background-color: #ddab2b;
}
.itm {
  margin: 10px 0px;
  box-shadow: 0px 0px 6px 1px black;
  -moz-box-shadow: 0px 0px 6px 1px black;
  -o-box-shadow: 0px 0px 6px 1px black;
  -webkit-box-shadow: 0px 0px 6px 1px black;
}
</style>
